import LogoSymbolColor from './svg/logo-symbol.svg?react';

type Props = {};

export default function LogoSymbol({}: Props) {
  return <LogoSymbolColor width={55} height={27} />;
}
